import { MilestoneSliderThumb } from '@optools/tools/milestones/components/milestone-slider-thumb';
import { formatSecondsHHMMSS } from '@optools/utils/format';
import { ComponentProps } from 'react';
import { Range } from 'react-range';

export type MilestonesRangeProps = Pick<ComponentProps<typeof Range>, 'onChange' | 'values'> & {
  duration: number;
};

export function MilestonesRange({ duration, onChange, values }: MilestonesRangeProps) {
  // Prevents the thumbs from overlapping
  const handleChange = (newValues: number[]) => {
    const [lower, upper] = newValues;
    const dynamicBuffer = duration * 0.0125;
    if (Math.abs(upper - lower) <= dynamicBuffer) {
      return;
    }

    onChange(newValues);
  };

  return (
    <div className="mb-24 flex flex-col gap-4">
      <p className="-ml-2 text-sm">Range</p>

      <Range
        max={Math.ceil(duration)}
        min={0}
        renderThumb={({ index, isDragged, props, value }) => (
          <MilestoneSliderThumb
            key={props.key}
            index={index}
            isDragged={isDragged}
            props={props}
            renderTooltipLabel={(value) => (
              <p className="text-sm whitespace-nowrap">{formatSecondsHHMMSS(value)}</p>
            )}
            value={value}
          />
        )}
        renderTrack={({ children, props }) => {
          return (
            <div {...props} className="relative h-1 w-full rounded-full bg-muted">
              {children}
            </div>
          );
        }}
        step={1}
        values={values}
        onChange={handleChange}
      />
    </div>
  );
}
